<!-- @format -->
<basic-information-form-tag>

    <table class="detail_table">
        <tr class="detail_table-row">
            <th class="information_table-heading">本名</th>
            <td class="information_table-data">
                <div class="box_flex02 field">
                    <div class="box_w40 margin-spacing-2_right">
                        <label class="form-heading" for="family_name">姓</label>
                        <input
                                id="family_name"
                                class="text_input"
                                type="text"
                                name="family_name"
                                is="binding-tag"
                                errmsg="入力してください"
                        >
                    </div>
                    <div class="box_w40 field">
                        <label class="form-heading" for="last_name">名</label>
                        <input
                                id="last_name"
                                class="text_input"
                                type="text"
                                name="last_name"
                                is="binding-tag"
                                errmsg="入力してください"
                        >
                    </div>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">フリガナ</th>
            <td class="information_table-data">
                <div class="box_flex02">
                    <div class="box_w40 field margin-spacing-2_right">
                        <label class="form-heading" for="family_kana">姓</label>
                        <input
                                id="family_kana"
                                class="text_input"
                                type="text"
                                name="family_kana"
                                is="binding-tag"
                                errmsg="カタカナで入力してください"
                        >
                    </div>
                    <div class="box_w40 field">
                        <label class="form-heading" for="last_kana">名</label>
                        <input
                                id="last_kana"
                                class="text_input"
                                type="text"
                                name="last_kana"
                                is="binding-tag"
                                errmsg="カタカナで入力してください"
                        >
                    </div>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">生年月日</th>
            <td class="information_table-data">
                <div class="box_flex01">
                    <div class="box_w50 field">
                        <input
                                class="text_input"
                                type="text"
                                name="birthday"
                                id="birthday"
                                is="binding-tag"
                                errmsg="入力してください"
                        />
                    </div>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="detail_table-heading">性別</th>
            <td class="detail_table-data">
                <div class="box_flex01">
                    <select name="sex" class="sort-list" is="binding-tag">
                        <option value="{key}" each={key in Object.keys(Sexes)}>{Sexes[key]}</option>
                    </select>
                </div>
            </td>
        </tr>
        <tr class="detail_table-row">
            <th class="information_table-heading">住所</th>
            <td class="information_table-data">
                <div class="inner_form">
                    <label class="form-heading" for="zip">郵便番号（ハイフンなし）</label>
                    <div class="box_w50 field">
                        <input
                                id="zip"
                                class="text_input narrow margin-spacing-3_bottom"
                                type="text"
                                name="zip"
                                maxlength='7'
                                is="binding-tag"
                                errmsg="入力してください"
                        >
                    </div>


                    <label class="form-heading" for="address1">住所1（都道府県 市区町村 番地）</label>
                    <div class="box_w50 field">
                        <input
                                id="address1"
                                class="text_input margin-spacing-3_bottom"
                                type="text"
                                name="address1"
                                is="binding-tag"
                                errmsg="入力してください"
                        >
                    </div>


                    <label class="form-heading" for="address2">住所2（建物名、フロアなど）</label>
                    <div class="box_w50">
                        <input
                                id="address2"
                                class="text_input"
                                type="text"
                                name="address2"
                                is="binding-tag"
                        >
                    </div>
                </div>
            </td>
        </tr>
    </table>

    <info-identity-tag></info-identity-tag>

    <invoice-provider-form-tag></invoice-provider-form-tag>

    <div class="wrap_button margin-spacing-3_top">
        <div
                class="button button-primary"
                onclick="{ submit }"
                type="button"
                value="更新を申請する"
                data-target=""
        ><span class="icon_documents"></span>更新を申請する
        </div>
    </div>

    <script>
        import identityPage from "@tags/pages/info/identity.riot";
        import basicInformation from "@model/basicInformation/api";
        import bindingTag from "@tags/parts/info/basic-information/binding.riot";
        import invoiceProviderForm from "@tags/parts/info/basic-information/invoice-provider-form.riot";

        export default {
            components: {
                'info-identity-tag': identityPage,
                'binding-tag': bindingTag,
                'invoice-provider-form-tag': invoiceProviderForm,
            },
            basicInformation: basicInformation,
            Sexes: {
                1: '男性',
                2: '女性',
                3: 'その他',
                4: '無回答'
            },
            state: {
                invoice_provider_number_error_message: '',
            },
            onBeforeMount() {
                this.basicInformation.trigger('fetch')
            },
            onMounted() {
                window.$("#birthday").flatpickr({
                    locale: "ja",
                });
            },
            submit(e) {

                e.preventDefault()
                if (!this.required_vaild()) {
                    alert('入力されていない項目があります。')
                    return false;
                }
                this.basicInformation.trigger('save')
            },
            required_vaild() {
                let isvalid = true
                const fields = document.getElementsByClassName('text_input')
                let invoice_provider_number_element = null;
                let invoice_provider_number_body = "";
                let invoice_provider_state = "";
                for (let item of fields) {

                    let pass = true;
                    let message = '入力してください'
                    switch (item.id) {
                        case 'address2':
                            break;
                        case 'zip':
                            if (!item.value.match(/^\d+$/)) {
                                pass = false;
                                message = '半角数値を入力してください';
                            }
                            break;
                        case 'img-upload':
                            if (!item.value) {
                                pass = false;
                                message = '画像の指定がありません';
                            }
                            break;
                        case 'invoice_provider_number_body':
                            invoice_provider_number_element = item;
                            invoice_provider_number_body = item.value;
                            invoice_provider_state = this.basicInformation.item.invoice_provider_state;
                            break;
                        default:
                            if (!item.value) {
                                pass = false;
                            }
                            break;
                    }
                    if (!pass && !item.classList.contains('is-error')) {
                        item.classList.add('is-error')
                        const div = document.createElement('div')
                        div.textContent = message
                        div.classList.add('error')
                        item.parentElement.appendChild(div)
                        isvalid = false
                    }

                    if ((invoice_provider_state === "yes") && (invoice_provider_number_body === "")) {
                        this.basicInformation.trigger("change_invoice_provider_number_error_on");
                    }
                }
                return isvalid
            }
        }
    </script>
</basic-information-form-tag>